<style lang="scss" scoped>
    .app-background {
        position: fixed;
        pointer-events: none;
        user-select: none;
        z-index: z(under);

        &,
        canvas,
        .gradient {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
        }

        &,
        .gradient {
            height: 100%;
        }

        canvas,
        .gradient {
            position: absolute;
            transition: height $transition-long, transform $transition-long;
        }

        canvas {
            display: block;
            background-color: $black;
            height: 400%
        }
        .gradient {
            background-image: linear-gradient(to bottom, $color-primary, transparent 500px);
        }
    }

</style>
<template>
    <div class="app-background">
        <canvas :style="{transform: staticHeight ? null : `translateY(-${100 * (progress / 4)}%)`, height: staticHeight ? '100%' : null}"></canvas>
        <div class="gradient" :style="{transform: `translateY(-${progress * 150}px)`}"></div>
    </div>
</template>
<script>
import raf from 'raf'
export default {
    name: 'AppBackground',
    data: () => ({
        ctx: null,
        width: null,
        height: null,
        raf: null,
        particles: [],
        mouse: null,
    }),
    computed: {
        canvas() {
            return this.$el.querySelector('canvas')
        },
    },
    props: {
        maxParticles: {
            type: Number,
            default: 500,
        },
        progress: {
            type: Number,
            default: 0,
        },
        staticHeight: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        draw() {
            this.ctx.clearRect(0, 0, this.width, this.height)
            this.update()
            this.raf = raf(this.draw)
        },
        update() {
            for (let i = 0; i < this.particles.length; i++) {
                let p = this.particles[i]

                // if (this.mouse) {
                //     let maxDistance = 100

                //     let posRelativeToMouse = {
                //         x: p.x - this.mouse.x,
                //         y: p.y - this.mouse.y,
                //     }

                //     let distance = Math.sqrt(
                //         (posRelativeToMouse.x * posRelativeToMouse.x) + (posRelativeToMouse.y * posRelativeToMouse.y)
                //     )
                //     if (distance < maxDistance) {
                //         let forceDirection = {
                //             x: posRelativeToMouse.x / distance,
                //             y: posRelativeToMouse.y / distance,
                //         }

                //         let force = (maxDistance - distance) / maxDistance
                //         p.dy += forceDirection.y * force
                //     }
                // }

                p.x += p.dx
                p.y += p.dy

                if (p.x > this.width) {
                    p.x = 0
                }

                if (p.x < 0) {
                    p.x = this.width
                }

                if (p.y < 0) {
                    p.y = this.height
                }

                if (p.y > this.height) {
                    p.y = 0
                }

                this.particles[i] = p
                this.ctx.fillStyle = `hsla(${p.hue}, ${p.sat}%, 95%, ${p.y / this.height})`
                this.ctx.beginPath()
                this.ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
                this.ctx.closePath()
                this.ctx.fill()
            }
        },
        resize(keppPositions) {
            let oldWidth = this.width
            let oldHeight = this.height
            this.width = this.canvas.width = this.canvas.scrollWidth
            this.height = this.canvas.height = this.canvas.scrollHeight
            let newWidth = this.width
            let newHeight = this.height
            if (keppPositions !== true) {
                let widthRatio = newWidth / oldWidth
                let heighthRatio = newHeight / oldHeight
                for (let i = 0; i < this.maxParticles; i++) {
                    this.particles[i].x *= widthRatio
                    this.particles[i].y *= heighthRatio
                }
            }
        },
        getMousePos(e) {
            let rect = this.canvas.getBoundingClientRect()
            this.mouse = {
                x: e.clientX - rect.left,
                y: e.clientY - rect.top,
            }
        },
        getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min
        },
        getRandom(min, max) {
            return (Math.random() * (max - min)) + min
        },
        getNonZeroRandom(min, max) {
            let rand = this.getRandom(min, max)
            return rand !== 0 ? rand : this.getNonZeroRandom(min, max)
        },
        createParticle() {
            let colorRange = [0, 60, 240]
            let dx = this.getNonZeroRandom(-0.025, 0.025)
            let dy = this.getNonZeroRandom(-0.05, -0.25)
            return {
                x: Math.random() * this.width,
                y: Math.random() * this.height,
                r: Math.random() * this.getNonZeroRandom(1, 4),
                dx,
                dy,
                odx: dx,
                ody: dy,
                hue: colorRange[this.getRandomInt(0, colorRange.length - 1)],
                sat: this.getRandomInt(50, 100),
            }
        },
        fillParticles() {
            let particles = []
            for (let i = 0; i < this.maxParticles; i++) {
                particles.push(this.createParticle())
            }
            this.particles = particles
        },
    },
    mounted() {
        this.ctx = this.canvas.getContext('2d')
        this.resize(true)
        window.addEventListener('resize', this.resize)
        window.addEventListener('mousemove', this.getMousePos)
        this.fillParticles()
        this.raf = raf(this.draw)
    },
    updated() {
        raf.cancel(this.raf)
        this.raf = raf(this.draw)
    },
    destroyed() {
        raf.cancel(this.raf)
        window.removeEventListener('resize', this.resize)
        window.removeEventListener('mousemove', this.getMousePos)
    },
}
</script>
